import { inject } from 'vue';
export const PanelPickerContext = Symbol('PanelPickerContext');
export const usePanelPickerContext = () => {
    return inject(PanelPickerContext);
};
export const PanelPresetsContext = Symbol('PanelPresetsContext');
export const usePanelPresetsContext = () => {
    return inject(PanelPresetsContext);
};
